"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCell = void 0;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const file_field_1 = require("../../file-field/file-field");
function FileCell({ value }) {
    return (react_1.default.createElement(file_field_1.FileField, { disabled: true, value: value, onChange: lodash_1.noop, showUpload: false, showClear: false }));
}
exports.FileCell = FileCell;
//# sourceMappingURL=file-cell.js.map